import { BaseStore } from "@omni/types/enums/baseStore.enum";
import { ConfigType } from "@omni/types/enums/configType.enum";
import { Environment } from "@omni/types/enums/environment.enum";

import { getConfig } from "./configManager";
import { getProvider, setProvider } from "./configProvider";

const EnvFallback = Environment.Prod;

const isValidEnvironement = (env: string | undefined): env is Environment => {
    return Object.values(Environment).includes(env as Environment);
};

export const isValidBaseStore = (
    baseStore: string | undefined
): baseStore is BaseStore => {
    return Object.values(BaseStore).includes(baseStore as BaseStore);
};

export const getEnvironment = (): string => {
    const prcEnvironment = process?.env?.ENV;
    if (isValidEnvironement(prcEnvironment)) {
        return prcEnvironment;
    }
    return EnvFallback;
};

export const isConfigValid = (schemaType: ConfigType) => {
    try {
        getConfig(schemaType);
        return true;
    } catch {
        return false;
    }
};

export const ConfigProvider = {
    getProvider,
    setProvider
};

export const ConfigManager = {
    getConfig
};
